import { Globals } from "../CoreApp/Globals";

export function handleMobileKeyboard() {
  var inputElement = document.getElementById("hiddenInput");
  if (!inputElement || !Globals._mobileDevice) return;

  if (Globals._keypadPanel) {
    // Un-hide the input
    inputElement.style.visibility = "visible";
    // Focus on it so keyboard pops
    inputElement.focus();
    var canvasElement = document.getElementById("basecanvas");
    canvasElement.contentEditable = "true";
  } else {
    inputElement.style.visibility = "hidden";
  }
}
